import './Donations.css';

import { IonRow } from '@ionic/react';
import React from 'react';

import Donation from '../../components/donation/Donation';
import ContentSpinner from '../../components/loading/ContentSpinner';
import { Empty } from '../../layouts/errors/Empty';
import { heartOutline } from 'ionicons/icons';

interface Props {
    data: Array<string>,
    loadMore?: any
}

const Donations: React.FC<Props> = (props) => {
    return <ContentSpinner loadData={props.loadMore}>
        <IonRow>
            <Empty text="حمایتی ثبت نشده است!" icon={heartOutline} length={props.data?.length}>
                {props.data.map((item: any) => {
                    return <Donation link={item['user_id'] == 61 ? "/fund" : undefined} avatar={item['avatar']} title={item['fullname']} date={item['date']} price={item['price']} text={item['details']?.donationsCount} />
                })}
            </Empty>
        </IonRow>
    </ContentSpinner>
}

export default Donations